<template>
  <div>
    <!-- Start Page Content -->
    <div class="breadcrumb">
      <h1 class="mr-2">Dashboard</h1>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <!-- ICON BG-->
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="i-Truck"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Trucks</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                {{ systemTrucks.length }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="i-Bag"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Products</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                {{ systemProducts.length }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="i-Money-2"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Total sales</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                {{ systemTotalsales }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">
              Total Sales by Product for Current Month
            </div>
            <div ref="chart2" style="width: 100%; height: 450px"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">Transporter Distribution Chart</div>
            <div ref="chart" style="width: 100%; height: 450px"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">Top 10 Purchased products</div>
            <div ref="chart3" style="width: 100%; height: 450px"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">Top 20 Selling Products</div>
            <div ref="pieChart" style="width: 100%; height: 450px"></div>
          </div>
        </div>
        
      </div>
     
    </div>
    <!-- End PAge Content -->
  </div>
</template>
<script>
import authservice from "../configurations/authentications/auth";
import router from "../router/index";
import { mapActions, mapGetters } from "vuex";
import * as echarts from "echarts";
export default {
  data() {
    return {
      chartLoaded: false, // Track the chart loading state
    };
  },
  created() {
    let Auth = new authservice();

    const expireTime = Auth.loggedIn();
    if (expireTime === false) {
      router.push("/login");
    }
    this.loadProduct();
    this.loadTrucks();
    this.loadProductstat();
  },
  computed: {
    ...mapGetters([
      "systemProducts",
      "systemTrucks",
      "systemProductstat",
      "systemTotalsales",
      "systemTotalpurchases",
      "systemTotalSales",
    ]),
  },
  mounted() {
    setTimeout(() => {
      // Your chart initialization code here

      // Initialize the ECharts instance with the chart container element
      const chart = echarts.init(this.$refs.chart);

      // Create an object to count the number of trucks for each transporter
      const transporterCounts = {};

      // Count trucks by transporter
      this.systemTrucks.forEach((truck) => {
        const transporter = truck.transporter_name;

        if (!transporterCounts[transporter]) {
          transporterCounts[transporter] = 1;
        } else {
          transporterCounts[transporter]++;
        }
      });

      // Create the chart data
      const chartData = Object.keys(transporterCounts).map((transporter) => ({
        name: transporter,
        value: transporterCounts[transporter],
      }));

      // Create the chart options
      const chartOptions = {
        // title: {
        //   text: "Transporter Distribution Chart",
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        // legend: {
        //   orient: "horizontal",
        //   right: "left",
        //   data: Object.keys(transporterCounts),
        // },
        series: [
          {
            name: "Transporter Trucks",
            type: "pie",
            radius: "80%",
            center: ["50%", "50%"],
            data: chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      // Set the chart options and render the chart
      chart.setOption(chartOptions);

      this.chartLoaded = true;

      // Initialize the ECharts instance for the bar chart
      const chart2 = echarts.init(this.$refs.chart2);

      // Extract product names, total sales, and sales month from the query results
      const productNames = this.systemProductstat.map(
        (item) => item.product_name
      );
      const totalSales = this.systemProductstat.map((item) => item.total_sales);
      const salesMonth = this.systemProductstat.map((item) => item.sales_month);

      // Create the chart options for the bar chart
      const chart2Options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: productNames.map(
            (productName, index) => `${productName} - ${salesMonth[index]}`
          ),
          axisLabel: {
            interval: 0, // Show all labels without skipping
            rotate: 25,
            fontSize: 9.5, // Rotate labels by 45 degrees for better readability
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Total Sales",
            type: "bar",
            data: totalSales,
            label: {
              show: true,
              rotate: 15,
              position: "top", // Display labels at the top of bars
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            start: 0,
            end: 5,
            top: "0",
          },
        ],
      };

      // Set the chart options and render the bar chart
      chart2.setOption(chart2Options);
      // Chart 3: New Chart for systemTotalpurchases
      const chart3 = echarts.init(this.$refs.chart3);
      // Extract data for systemTotalpurchases
      const purchaseNames = this.systemTotalpurchases.map(
        (item) => item.product_name
      );
      const purchaseValues = this.systemTotalpurchases.map(
        (item) => item.total_quantity_received
      );

      // Create options for Chart 3 (Bar Chart)
      const chart3Options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: purchaseNames,
          axisLabel: {
            interval: 0, // Show all labels without skipping
            rotate: 25,
            fontSize: 9.5, // Rotate labels by 45 degrees for better readability
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Total Purchases",
            type: "bar",
            data: purchaseValues,
            label: {
              show: true,
              rotate: 25,
              fontSize: 9.5,
              position: "top", // Display labels at the top of bars
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            start: 0,
            end: 50,
            top: "0",
          },
        ],
      };

      // Set the chart options and render Chart 3
      chart3.setOption(chart3Options);

      // Initialize the ECharts instance with the chart container element
      const pieChart = echarts.init(this.$refs.pieChart);

      // Extract data for the pie chart
      const pieData = this.systemTotalSales.map((item) => ({
        name: item.product_name,
        value: item.total_quantity_sold,
      }));

      // Find the index of the data point with the highest value
      let highestIndex = 0;
      for (let i = 1; i < pieData.length; i++) {
        if (pieData[i].value > pieData[highestIndex].value) {
          highestIndex = i;
        }
      }
      // Create the chart options for the pie chart
      const pieChartOptions = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        // legend: {
        //   orient: "vertical",
        //   left: "left",
        //   data: pieData.map((item) => item.name),
        // },
        series: [
          {
            name: "Total Sales",
            type: "pie",
            radius: "85%", // Increase the radius value to make the pie chart larger
            center: ["50%", "50%"],
            data: pieData.map((item, index) => {
              // Detach the highest value slice
              if (index === highestIndex) {
                return {
                  ...item,
                  emphasis: {
                    scale: false,
                    focus: "self",
                  },
                };
              } else {
                return item;
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      // Set the chart options and render the pie chart
      pieChart.setOption(pieChartOptions);
      this.chartLoaded = true; // Set chartLoaded to true when charts are loaded
    }, 2000);
  },

  methods: {
    ...mapActions(["loadProduct", "loadTrucks", "loadProductstat"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/dashboard/index.vue